import { Link } from "react-router-dom";
import { Home, ChevronRight } from "react-feather";
import styles from "./layout.module.css";

/**
 * Reusable top-of-page header: breadcrumb trail + page title.
 *
 * <PageHeader title="Dashboard" />
 * <PageHeader
 *   title="Make A Booking"
 *   trail={[{ label: "Bookings", to: "/booking/list" }]}
 * />
 *
 * `trail` only needs the ancestor steps — the current page (bold, not a
 * link) is rendered automatically from `title`. Home always links to
 * /dashboard and is added automatically.
 */
const PageHeader = ({ title, trail = [] }) => {
    return (
        <div className={`${styles.PageHeaderWrap}`}>
            <nav className={`${styles.Breadcrumb}`} aria-label="Breadcrumb">
                <Link to="/dashboard" className={`${styles.BreadcrumbHome}`} aria-label="Dashboard home">
                    <Home />
                </Link>

                {trail.map((item, idx) => (
                    <span className={`${styles.BreadcrumbCrumb}`} key={`${item.label}-${idx}`}>
                        <ChevronRight className={`${styles.BreadcrumbSep}`} />
                        {item.to
                            ? <Link to={item.to} className={`${styles.BreadcrumbLink}`}>{item.label}</Link>
                            : <span className={`${styles.BreadcrumbLink}`}>{item.label}</span>}
                    </span>
                ))}

                <span className={`${styles.BreadcrumbCrumb}`}>
                    <ChevronRight className={`${styles.BreadcrumbSep}`} />
                    <span className={`${styles.BreadcrumbCurrent}`}>{title}</span>
                </span>
            </nav>

            <h1 className={`${styles.PageHeaderTitle}`}>{title}</h1>
        </div>
    );
};

export default PageHeader;